import React, { useState, useEffect } from 'react';
import { Button, Modal, Form, Input, Select } from 'antd';
import { FetchVariable } from '../../../Components/FetchVariable/FetchVariable';

const { Option } = Select;
const TaskAddForm = ({ visible, onCreate, onCancel }) => {
  
  const [form] = Form.useForm();
  
  const [vehicleData, setVehicleDta] = useState()

  useEffect(() => {
      fetch([`${FetchVariable.Heroku}/vehicle/vehicle-repair-detail`])
        .then(response => response.json())
        .then(data => {
          setVehicleDta(data);
        })
        .catch(err => console.log(err));
    }, []); // eslint-disable-line

  return (
    <Modal
      visible={visible}
      title="Create a new task"
      okText="Create"
      cancelText="Cancel"
      onCancel={onCancel}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            form.resetFields();
            onCreate(values);
          })
          .catch((info) => {
            console.log('Validate Failed:', info);
          });
      }}

    >
      <Form
        form={form}
        layout="vertical"
        name="TaskForm"
        initialValues={{
          TaskID:'',
          VehicleID:'',
          Task:'',
    
      }}
      >
        <Form.Item name="VehicleID" label="Select Vehicle">
          <Select 
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {vehicleData?.map(vehicle=><Option value={vehicle.VehicleID} key={vehicle.VehicleID}>{vehicle.VehicleID} : {vehicle.Make} {vehicle.Model} --- {vehicle.VehicleVIN}</Option>)}
          </Select>
        </Form.Item>
        <Form.Item name="Task" label="Task">
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};

const TaskAdd = ( props ) => {
  const [visible, setVisible] = useState(false);

  const onCreate = (values) => {
    props.addTask(values)
    setVisible(false);
  };

  return (
    <div>
      <Button
        type="primary"
        onClick={() => {
          setVisible(true);
        }}
      >
      Add New Task
      </Button>
      <TaskAddForm
        visible={visible}
        onCreate={onCreate}
        onCancel={() => {
          setVisible(false);
        }}
      />
    </div>
  );
};

export default TaskAdd